import { render, staticRenderFns } from "./CCBonus.vue?vue&type=template&id=571b500a&"
import script from "./CCBonus.vue?vue&type=script&lang=ts&"
export * from "./CCBonus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports